import { createContext, useContext } from 'react';
import { BlueprintMetadata, Languages, ReportDefinitionEntity } from '../../types';

interface DefinitionContextValue {
  blueprint: BlueprintMetadata;
  initialDefinition: ReportDefinitionEntity;
  languages: Languages;
}

const DefinitionContext = createContext<DefinitionContextValue | undefined>(undefined);

export function DefinitionContextProvider({
  children,
  blueprint,
  initialDefinition,
  languages,
}: {
  children: React.ReactNode;
  blueprint: BlueprintMetadata;
  initialDefinition: ReportDefinitionEntity;
  languages: Languages;
}) {
  return (
    <DefinitionContext.Provider value={{ blueprint, initialDefinition, languages }}>
      {children}
    </DefinitionContext.Provider>
  );
}

export function useDefinitionContext(): DefinitionContextValue {
  const context = useContext(DefinitionContext);
  if (!context) {
    throw new Error('useDefinitionContext must be used within DefinitionContextProvider');
  }
  return context;
}
